import React from 'react';
import { FileText } from 'lucide-react';
import PolicyLayout, { Section, P, Li, Ul } from './PolicyLayout';

export default function TermsPage() {
  return (
    <PolicyLayout
      title="Terms & Conditions"
      subtitle="Please read carefully before using the Platform"
      icon={FileText}
    >
      <Section title="1. Acceptance of Terms">
        <P>
          By accessing or using the Shine Jewellery platform ("Platform"), you agree to be bound
          by these Terms and Conditions. If you do not agree, please discontinue use immediately.
        </P>
      </Section>

      <Section title="2. About the Platform">
        <P>
          Shine Jewellery is a gold investment platform that allows users to invest money in
          gold-backed schemes, withdraw accumulated returns, and redeem their investment as
          physical gold jewellery from our store.
        </P>
      </Section>

      <Section title="3. Eligibility">
        <Ul>
          <Li>You must be 18 years of age or older.</Li>
          <Li>You must be a resident of India with a valid government-issued ID.</Li>
          <Li>You must provide accurate personal and financial information during registration.</Li>
          <Li>One account per individual; multiple accounts are not permitted.</Li>
        </Ul>
      </Section>

      <Section title="4. Investment Terms">
        <Ul>
          <Li>Investments are made in Indian Rupees (INR) through the Platform.</Li>
          <Li>Minimum investment amount is ₹155 per transaction.</Li>
          <Li>
            Gold value is calculated based on prevailing market rates at the time of redemption,
            not at the time of investment.
          </Li>
          <Li>Approved investments begin accruing returns as per the scheme selected.</Li>
          <Li>
            Shine Jewellery reserves the right to modify scheme terms with 30 days prior notice.
          </Li>
        </Ul>
      </Section>

      <Section title="5. Payments">
        <Ul>
          <Li>All payments are processed securely via Razorpay Payment Gateway.</Li>
          <Li>We accept UPI, Net Banking, Debit/Credit Cards, and Wallets.</Li>
          <Li>
            Transaction charges, if any, are levied by the payment gateway and are non-refundable.
          </Li>
          <Li>Payment confirmation is subject to bank processing times.</Li>
        </Ul>
      </Section>

      <Section title="6. Withdrawals">
        <Ul>
          <Li>Withdrawal requests are processed within 5–7 business days after admin approval.</Li>
          <Li>Amounts are transferred to the bank account registered on your profile.</Li>
          <Li>A minimum balance must be maintained as per the active scheme terms.</Li>
          <Li>Shine Jewellery may place withdrawal holds during audits or disputes.</Li>
        </Ul>
      </Section>

      <Section title="7. Gold Redemption">
        <Ul>
          <Li>Users may redeem their balance as physical gold jewellery from our store.</Li>
          <Li>Gold redemption is subject to availability and current gold rates.</Li>
          <Li>Making charges and applicable taxes are borne by the customer.</Li>
          <Li>Redemption requests must be raised at least 7 days in advance.</Li>
        </Ul>
      </Section>

      <Section title="8. Account Suspension">
        <P>
          Shine Jewellery reserves the right to suspend or terminate accounts involved in
          fraudulent activity, misrepresentation, or violation of these terms without prior notice.
        </P>
      </Section>

      <Section title="9. Limitation of Liability">
        <P>
          Shine Jewellery is not liable for losses arising from market fluctuations, force majeure
          events, or third-party payment failures beyond our reasonable control.
        </P>
      </Section>

      <Section title="10. Governing Law">
        <P>
          These Terms are governed by the laws of India. Disputes shall be subject to the exclusive
          jurisdiction of courts in [Your City], India.
        </P>
      </Section>
    </PolicyLayout>
  );
}
